/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/shop.compontents.module.ts.
 */
import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {
  ShopViewFieldValueRendererComponent
} from './components/view-field-value-renderer/shop.view-field-value-renderer.component';
import {
  ShopWarenkorbEntryEditFieldsComponent
} from './components/warenkorb-entry-edit-fields/shop.warenkorb-entry-edit-fields.component';
import {
  ShopVerfuegbarkeitsInfoButtonComponent
} from './components/verfuegbarkeits-info-button/shop.verfuegbarkeits-info-button.component';
import {ShopArtikelStatusIconComponent} from './components/artikel-status-icon/shop.artikel-status-icon.component';
import {
  ShopArtikelAktionenButtonComponent
} from './components/artikel-aktionen-button/shop.artikel-aktionen-button.component';
import {ShopArtikelNoteComponent} from './components/artikel-note/shop.artikel-note.component';
import {ShopViewComponent} from './components/view/shop.view.component';
import {RouterModule} from '@angular/router';
import {
  ShopWarenkorbImportTickerComponent
} from './components/warenkorb-import-ticker/shop.warenkorb-import-ticker.component';
import {ShopViewFilterComponent} from './components/view-filter/shop.view-filter.component';
import {ShopViewResultTableCompontent} from './components/view-result-table/shop.view-result-table.compontent';
import {ShopViewResultBoxCompontent} from './components/view-result-box/shop.view-result-box.compontent';
import {ShopViewFilterMenuComponent} from './components/view-filter-menu/shop.view-filter-menu.component';
import {ShopViewActionComponent} from './components/view-action/shop.view-action.component';
import {
  ShopArtikelAktionenDetailsComponent
} from './components/artikel-aktionen-details/shop.artikel-aktionen-details.component';
import {ShopWarenkorbButtonComponent} from './components/warenkorb-button/shop.warenkorb-button.component';
import {ShopMerklistenButtonComponent} from './components/merklisten-button/shop.merklisten-button.component';
import {
  ShopWarenkorbActionInfoComponent
} from './components/warenkorb-action-info/shop.warenkorb-action-info.component';
import {
  ShopMerklisteActionInfoComponent
} from './components/merkliste-action-info/shop.merkliste-action-info.component';
import {
  ShopDialogsVertreterAddToWarenkorbComponent
} from './dialogs/vertreter-add-to-warenkorb/shop.dialogs.vertreter-add-to-warenkorb.component';
import {
  ShopWarenkorbBestellblockButtonComponent
} from './components/warenkorb-bestellblock-button/shop.warenkorb-bestellblock-button.component';
import {ShopWarenkorbBoxComponent} from './components/warenkorb-box/shop.warenkorb-box.component';
import {ShopWarenkorbTableComponent} from './components/warenkorb-table/shop.warenkorb-table.component';
import {ShopAjaxWarenkorbComponent} from './components/ajax-warenkorb/shop.ajax-warenkorb.component';
import {ShopMerklisteMenuComponent} from './components/merkliste-menu/shop.merkliste-menu.component';
import {ShopWarenkorbMenuComponent} from './components/warenkorb-menu/shop.warenkorb-menu.component';
import {
  ShopViewFilterBottomsheetComponent
} from './components/view-filter-bottomsheet/shop.view-filter-bottomsheet.component';
import {ShopMerklisteTableComponent} from './components/merkliste-table/shop.merkliste-table.component';
import {ShopBonusPunkteIconsComponent} from './components/bonus-punkte-icons/shop.bonus-punkte-icons.component';
import {
  ShopDialogsBonusPunkteDetailsComponent
} from './dialogs/bonus-punkte-details/shop.dialogs.bonus-punkte-details.component';
import {ShopViewArticleDetailsComponent} from './components/view-article-details/shop.view-article-details.component';
import {
  ShopViewArticleDetailsInfoComponent
} from './components/view-article-details-info/shop.view-article-details-info.component';
import {StatisticsComponentsModule} from '../statistics/statistics.components.module';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {
  ShopCustomerSpecialPriceEditButtonComponent
} from './components/customer-special-price-edit-button/shop.customer-special-price-edit-button.component';
import {
  ShopDialogsCustomerSpecialPriceListComponent
} from './dialogs/customer-special-price-list/shop.dialogs.customer-special-price-list.component';
import {
  ShopAlternativArtikelButtonComponent
} from './components/alternativ-artikel-button/shop.alternativ-artikel-button.component';
import {ShopSupplierMenuComponent} from './components/supplier-menu/shop.supplier-menu.component';
import {
  ShopArtikelVerfuegbarkeitInlineInfoComponent
} from './components/artikel-verfuegbarkeit-inline-info/shop.artikel-verfuegbarkeit-inline-info.component';
import {CarouselComponent} from 'ngx-carousel-ease';
import {
  ShopDtpZusatzdatenFieldEditorComponent
} from './components/dtp-zusatzdaten-field-editor/shop.dtp-zusatzdaten-field-editor.component';
import {
  ShopDtpZusatzdatenEditorComponent
} from './components/dtp-zusatzdaten-editor/shop.dtp-zusatzdaten-editor.component';
import {
  ShopArtikelAktionenStageComponent
} from './components/artikel-aktionen-stage/shop.artikel-aktionen-stage.component';
import {
  ShopEinkaufsStatistikWebButtonComponent
} from './components/einkaufs-statistik-web-button/shop.einkaufs-statistik-web-button.component';
import {
  ShopEinkaufsStatitikWebDetailsComponent
} from './components/einkaufs-statitik-web-details/shop.einkaufs-statitik-web-details.component';
import {
  ShopDialogsTryaddArtToWkConfirmComponent
} from "./dialogs/tryadd-art-to-wk-confirm/shop.dialogs.tryadd-art-to-wk-confirm.component";
import {
  ShopDialogsImportHinweisComponent
} from './dialogs/import-hinweis/shop.dialogs.import-hinweis.component';
import {
  ShopDialogsNachliefernMultiFrageComponent
} from "./dialogs/nachliefern-multi-frage/shop.dialogs.nachliefern-multi-frage.component";
import {
  ShopDialogsAlternativArtikelSucheComponent
} from "./dialogs/alternativ-artikel-suche/shop.dialogs.alternativ-artikel-suche.component";
import {
  ShopDialogsVerfuegbarkeitsCheckConfirmComponent
} from "./dialogs/verfuegbarkeits-check-confirm/shop.dialogs.verfuegbarkeits-check-confirm.component";
import {
  ShopArtikelVerfuegbarkeitInfoComponent
} from "./components/artikel-verfuegbarkeit-info/shop.artikel-verfuegbarkeit-info.component";
import {
  ShopDialogsWarenguthabenDetailsComponent
} from './dialogs/warenguthaben-details/shop.dialogs.warenguthaben-details.component';

@NgModule({
  declarations: [
    ShopViewFieldValueRendererComponent,
    ShopWarenkorbEntryEditFieldsComponent,
    ShopVerfuegbarkeitsInfoButtonComponent,
    ShopArtikelStatusIconComponent,
    ShopArtikelAktionenButtonComponent,
    ShopEinkaufsStatistikWebButtonComponent,
    ShopArtikelAktionenStageComponent,
    ShopArtikelNoteComponent,
    ShopViewComponent,
    ShopWarenkorbImportTickerComponent,
    ShopViewFilterComponent,
    ShopViewFilterMenuComponent,
    ShopViewResultTableCompontent,
    ShopViewResultBoxCompontent,
    ShopViewActionComponent,
    ShopArtikelAktionenDetailsComponent,
    ShopWarenkorbButtonComponent,
    ShopMerklistenButtonComponent,
    ShopWarenkorbActionInfoComponent,
    ShopMerklisteActionInfoComponent,
    ShopDialogsVertreterAddToWarenkorbComponent,
    ShopWarenkorbBestellblockButtonComponent,
    ShopWarenkorbBoxComponent,
    ShopWarenkorbTableComponent,
    ShopAjaxWarenkorbComponent,
    ShopMerklisteMenuComponent,
    ShopWarenkorbMenuComponent,
    ShopSupplierMenuComponent,
    ShopViewFilterBottomsheetComponent,
    ShopMerklisteTableComponent,
    ShopBonusPunkteIconsComponent,
    ShopDialogsBonusPunkteDetailsComponent,
    ShopViewArticleDetailsComponent,
    ShopViewArticleDetailsInfoComponent,
    ShopCustomerSpecialPriceEditButtonComponent,
    ShopDialogsCustomerSpecialPriceListComponent,
    ShopAlternativArtikelButtonComponent,
    ShopArtikelVerfuegbarkeitInlineInfoComponent,
    ShopDtpZusatzdatenEditorComponent,
    ShopDtpZusatzdatenFieldEditorComponent,
    ShopEinkaufsStatitikWebDetailsComponent,
    ShopDialogsTryaddArtToWkConfirmComponent,
    ShopDialogsImportHinweisComponent,
    ShopDialogsNachliefernMultiFrageComponent,
    ShopDialogsAlternativArtikelSucheComponent,
    ShopDialogsVerfuegbarkeitsCheckConfirmComponent,
    ShopArtikelVerfuegbarkeitInfoComponent,
    ShopDialogsWarenguthabenDetailsComponent,
  ],
  exports: [
    ShopDtpZusatzdatenEditorComponent,
    ShopViewFilterBottomsheetComponent,
    ShopWarenkorbMenuComponent,
    ShopMerklisteMenuComponent,
    ShopWarenkorbBoxComponent,
    ShopWarenkorbTableComponent,
    ShopDtpZusatzdatenFieldEditorComponent,
    ShopViewResultTableCompontent,
    ShopViewResultBoxCompontent,
    ShopViewFilterComponent,
    ShopWarenkorbImportTickerComponent,
    ShopViewFieldValueRendererComponent,
    ShopWarenkorbEntryEditFieldsComponent,
    ShopVerfuegbarkeitsInfoButtonComponent,
    ShopArtikelStatusIconComponent,
    ShopArtikelAktionenButtonComponent,
    ShopEinkaufsStatistikWebButtonComponent,
    ShopEinkaufsStatitikWebDetailsComponent,
    ShopArtikelAktionenStageComponent,
    ShopArtikelNoteComponent,
    ShopViewComponent,
    ShopViewActionComponent,
    ShopWarenkorbButtonComponent,
    ShopMerklisteTableComponent,
    ShopArtikelAktionenDetailsComponent,
    ShopViewArticleDetailsComponent,
    ShopViewArticleDetailsInfoComponent,
    ShopBonusPunkteIconsComponent,
    ShopAlternativArtikelButtonComponent,
    ShopDialogsTryaddArtToWkConfirmComponent,
    ShopDialogsNachliefernMultiFrageComponent,
    ShopDialogsAlternativArtikelSucheComponent,
    ShopDialogsVerfuegbarkeitsCheckConfirmComponent,
    ShopArtikelVerfuegbarkeitInfoComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([]),
    StatisticsComponentsModule,
    PdfJsViewerModule,
    CarouselComponent,
  ],
  providers: []
})
/**
 * Zweck: Beschreibt class ShopCompontentsModule und ihren Daten- oder Funktionsvertrag.
 */
export class ShopCompontentsModule {
}
